import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '8px'
    },
    padding: {
      gap: '20px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
